import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthCookieService, AuthService } from '@vinnova/auth';
import { finalize, of, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BedomareCommand } from '../../core/commands/bedomare.command';
import { ClaimResult } from '../../core/models/claim-result';

@UntilDestroy()
@Component({
  selector: 'app-assign-bedomare',
  templateUrl: './assign-bedomare.component.html',
  styleUrls: ['./assign-bedomare.component.scss'],
  standalone: false,
})
export class AssignBedomareComponent implements OnInit {
  errorMessage: string;
  isLoading: boolean;
  param: string;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private authCookieService: AuthCookieService,
    private translate: TranslocoService,
    private bedomareCommand: BedomareCommand,
    private router: Router,
  ) {}
  ngOnInit(): void {
    this.param = this.route.snapshot.queryParams['s'];
    if (this.param) {
      this.assignBedomare();
    }
  }

  assignBedomare() {
    this.isLoading = true;
    this.bedomareCommand
      .assignBedomare(this.param)
      .pipe(
        switchMap((result) => {
          switch (result) {
            case ClaimResult.Ok: {
              this.authCookieService.removeAllSites();
              return this.authService
                .login(
                  '/profile',
                  environment.b2cMsalConfig.authority +
                    this.authCookieService.getB2CCookieValue('tfp'),
                  [environment.b2cMsalConfig.scope],
                )
                .pipe(untilDestroyed(this));
            }
            case ClaimResult.ClaimAlreadyUsed: {
              this.errorMessage = this.translate.translate(
                'assign_role_bedomare_claim_already_used',
              );
              break;
            }
            case ClaimResult.UserAlreadyClaimedOtherUser: {
              this.errorMessage = this.translate.translate(
                'assign_role_bedomare_user_already_claimed',
              );
              break;
            }
            case ClaimResult.UserAlreadyClaimedSameUser: {
              this.router.navigate(['/profile']);
            }
          }
          return of(undefined);
        }),
        finalize(() => {
          this.isLoading = false;
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
